export default {
  'global#home': 'Home',
  'global#maps': 'Maps',
  'global#works': 'Tales',
  'global#date_human': 'Do MMMM YYYY',
  'global#layout_error_title': 'Sorry, an error has occurred',
  'global#layout_error_description':
      'Try reloading the page in a few moments and if the problem persists contact the platform administrator.',
  'global#facet_empty_text': 'No matches',
  'readmore#label': 'Show all',
  'search#maintitle': 'Sources',
  'search#records': 'Tales',
  'search#motifs': 'Motifs',
  'resource#related_motifs': 'Related motifs',
  'resource#related_records': 'Related records',
  'search#bibliography': 'Bibliography',
  'search#editions_total_0': 'No sources',
  'search#editions_total_1': '<strong>{ total }</strong> Source',
  'search#editions_total': '<strong>{ total }</strong> Sources',
  'search#motifs_total_0': 'No Motif',
  'search#motifs_total_1': '<strong>{ total }</strong> Motif',
  'search#motifs_total': '<strong>{ total }</strong> Motifs',
  'search#books_total': '<strong>{ total }</strong> Libri',
  'search#books_total_1': '<strong>{ total }</strong> Libro',
  'search#books_total_0': 'Nessun Libro',
  'search#witnesses_total': '<strong>{ total }</strong> Testimoni',
  'search#witnesses_total_1': '<strong>{ total }</strong> Testimone',
  'search#witnesses_total_0': 'Nessun Testimone',
  'search#placeholder_query': 'Search in titles',
  'search#placeholder_query-content': 'Search in the works contained',
  'search#header_subjects': 'Subjects',
  'search#header_records': 'Tales',
  'search#header_authors': 'Authors',
  'search#header_keywords': 'Keywords',
  'search#header_works': 'Works',
  'search#header_libraries': 'Biblioteca',
  'search#header_cities': 'Cities',
  'search#header_places': 'Places',
  'search#header_date': 'Periods',
  'search#header_editionType': 'Type of manuscript',
  'search#facets_title': 'Filter results',
  'search#filters_title': 'Active filters:',
  'search#resultsamount': 'Show n results:',
  'search#sort_title': 'Order',
  'search#sort_score': 'Order by relevance',
  'search#sort_asc': 'Alphabetical order (A→Z)',
  'search#sort_desc': 'Alphabetical order (Z→A)',
  'search#fallback_text':
      'Your search returned no matches. Try to change the parameters or to reset the search by clicking on the button below.',
  'search#fallback_button': 'Reset search',
  'search#ko_text':
      'Oops, we encountered a search error. Try to change the parameters or to reset the search by clicking on the button below.',
  'search#ko_button': 'Reset search',
  'search#description_button': 'Info',
  'search#description_link': 'Ok, I got it',
  'record#bibliography_title': 'Bibliography',
  'resource#title' : 'Source',
  'resource#authors': 'by',
  'resource#date': 'published',
  'resource#time_to_read': 'time to read',
  'resource#metadata': 'Metadata',
  'resource#metadata_size': 'Size',
  'resource#collection_references' : 'Connected edition and articles',
  'resource#collection_referencedBy' : 'Mentioned by',
  'resource#collection_isPartOf' : 'Part of',
  'resource#collection': 'Reletad editions and articles',
  'search#header_genres': 'Genres',
  'search#header_language': 'Language',
  'search#date': 'date',
  'search#bibliographies_total':
      '<strong>{ total }</strong> bibliographic references',
  'search#bibliographies_total_1':
      '<strong>{ total }</strong> bibliographic reference',
  'search#bibliographies_total_0': 'No bibliographic reference',
  'search#placeholder_authors': 'Search for an author',
  'search#title_bibliographies': 'Bibliography',
  'itinerary#related_res_title': 'Related resources',
  'timeline#title': 'Chronology of fairy tales and collections',
  'map#title': 'Map',
  'map#defaultText': 'Click on an item to see the details'
};
